import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/jedi-order': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M231.9 335.7L263.3 289.8 243.2 345.3 305.7 354.4 243.2 363.5 267.4 410.9S237.2 379.2 232.9 374.7C234.6 443.5 235.1 460.4 235.1 460.4S389.5 388.7 303.7 230.3C303.7 230.3 410.7 112.2 313.8 39.6 313.8 39.6 479.3 139.5 374.3 311 374.3 311 461.1 226.3 415.7 140.5 415.7 140.5 494.4 251.5 398.5 373.6 398.5 373.6 424.8 357.4 448 295.9 448 295.9 431.1 479.1 226 481.5V481.6H221.9V481.5C16.9 479.1 0 295.9 0 295.9 23.2 357.4 49.4 373.6 49.4 373.6-46.4 251.5 32.3 140.5 32.3 140.5-13.1 226.3 73.7 311 73.7 311-31.3 139.5 134.2 39.6 134.2 39.6 37.3 112.2 144.3 230.3 144.3 230.3 58.5 388.7 212.9 460.4 212.9 460.4S213.3 443.4 215.1 374.7L180.6 410.9 204.8 363.5 142.3 354.4 204.8 345.3 184.7 289.8 216.1 335.7C218.4 247.9 223.9 29.9 224 28.9L224 26.4 224 27.4 224 26.4 224 28.9C224.1 30.6 229.6 248.1 231.9 335.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/jedi-order.js
// module id = u9pW
// module chunks = 144